import { createApp } from '@wu/widget-core';
import { Banner } from './banner';
import { meta } from './meta';

export default createApp(meta, Banner);
